import React from 'react'
import styled from '@emotion/styled'

const Circle = styled.div`
  background: #222;
  color: #fff;
  padding: ${({full})=>full?'5px 12px':'3px'};
  border-radius:${({full})=>full?'15px':'50%'};
  display: ${({ca})=>ca?'flex':'none'};
  font-size: ${({full})=>full?'.8rem':'.6rem'};
  width: ${({full})=>full?'auto':'20px'};
  height: ${({full})=>full?'auto':'20px'};
  align-items: center;
  justify-content: center;
  position: absolute;
  right: 10px;
  bottom: 10px;
`

export default ({ca,full}) => (
	<Circle ca={ca} full={full}>
		<span>{full?'California Only':'CA'}</span>
	</Circle>
)